import { moduleState, state } from 'cerebral'
import { DateTime } from 'luxon'
import { isNil } from 'ramda'
import { crudActions } from '../factories'
import { upload } from '../../lib/util/cloudinary'
import apiClient from '../../lib/util/api-client'
import { captureException } from '../../lib/util/errors'
import { DesignHuddleClient, printExportOptions } from '../../lib/util/designhuddle'

const mediaEmbedUrlService = apiClient.service('media/embedurl')

export const { find, setList, clearList, get, save, remove, updateOrder } = crudActions({ name: 'medias' })

export const validateEmbedURL = async ({ props: { query } }) => mediaEmbedUrlService.find({ query })

export const toggleActive = async ({ props: { id }, mediasService: service, get }) => {
  if (id) {
    const active = get(moduleState`entities.${id}.active`)
    const data = await service.patch(id, { active: !active })
    return { entities: { medias: [data] } }
  }
}

export const saveDesign = async ({ props, app, mediasService, store }) => {
  const getEditorToken = app.getSequence(`publications.getEditorToken`)
  const signUpload = app.getSequence('uploads.signUpload')
  const { entities = {}, values: { editableLayout: { projectId: editorProjectId } = {}, updateDownloadableDesign = false } = {} } = props
  const { medias: [{ _id, title } = {}] = [] } = entities

  if (editorProjectId && updateDownloadableDesign) {
    try {
      store.set(moduleState`design.generating`, true)

      const { access_token } = await getEditorToken()
      const designHuddleClient = new DesignHuddleClient(access_token)
      const mediaDesign = await designHuddleClient.exportProject(editorProjectId, title, 'pdf', printExportOptions)

      let media = {}
      if (mediaDesign) {
        const blob = await fetch(mediaDesign.download_url).then((res) => res.blob())
        const design = await upload(blob, { signUpload, uploadPreset: 'editor-pdf', publicId: _id })
        media = await mediasService.patch(_id, { design })
      }

      store.set(moduleState`design.generating`, false)
      return { entities: { ...entities, medias: [media] } }
    } catch (error) {
      store.set(moduleState`design.generating`, false)
      captureException(error)
    }
  }
}

const setFilterOption = (name) => ({ props: { value }, store }) => {
  store.set(moduleState`filter.${name}`, value)
}

export const setParentMediaHidden = setFilterOption('excludeParentMedia')
export const setDisplayDevices = setFilterOption('devices')
export const setDisplayLocation = setFilterOption('displayLocation')

export const dashboardSetTimeRange = ({ props: { timeRange, days, offset }, store, get }) => {
  const timezone = get(state`account.currentUser.timezone`)
  store.set(moduleState`filter.timeRange`, timeRange)

  const now = DateTime.local()
    .setZone(timezone)
    .plus({ days: offset || 0 })
    .setZone('utc', { keepLocalTime: true })
    .startOf('day')

  const hasValidDays = !isNil(days)

  let startDate = null
  let endDate = null

  if (hasValidDays) {
    const isBackward = offset < 0
    const isForward = offset > 0

    if (isBackward) {
      startDate = now.minus({ days })
      endDate = now
    } else if (isForward) {
      startDate = now
      endDate = now.plus({ days })
    }
  }

  store.set(moduleState`filter.scheduleAt`, startDate && startDate.toISODate())
  store.set(moduleState`filter.scheduleEndAt`, endDate && endDate.toISODate())
}
